import { styled } from '@mui/material';

import { DESKTOP_MIN_WIDTH } from '~/constants/common';

export const StyledContainer = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: 24,
}));

export const StyledAutocompleteContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  gap: 16,
  alignItems: 'flex-end',
  [theme.breakpoints.down(DESKTOP_MIN_WIDTH)]: {
    flexDirection: 'column',
    alignItems: 'center',
  },
}));

export const StyledDetails = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: 16,
}));

export const StyledDetailRow = styled('div')(({ theme }) => ({
  display: 'flex',
  gap: 16,
  [theme.breakpoints.down(DESKTOP_MIN_WIDTH)]: {
    flexDirection: 'column',
  },
}));
